import axios from 'axios'

var http = axios.create({
  baseURL: process.env.API_BASE_URL + '/account',
  headers: { 'Content-Type': 'application/json' }
})

http.interceptors.response.use(function (response) {
  return response
}, function (error) {
  if (error.response.status !== 401) return Promise.reject(error)

  var refreshAndRetry = new Promise(function (resolve) {
    axios.post(process.env.API_BASE_URL + '/account/refresh_token',
      {
        'refresh_token': JSON.parse(localStorage.getItem('refresh_token')).value
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('token')).value
        }
      }).then(function (response) {
        localStorage.setItem('refresh_token', JSON.stringify({
          value: response.data.refresh_token,
          expire: null
        }))

        localStorage.setItem('token', JSON.stringify({
          value: response.data.token,
          expire: null
        }))

        return Promise.resolve(response)
      }).then(function (response) {
        var failedRequest = error.config
        failedRequest.headers.Authorization = 'Bearer ' + JSON.parse(localStorage.getItem('token')).value
        axios.request(failedRequest).then(function (retryResponse) {
          resolve(retryResponse)
        })
      })
  })

  return refreshAndRetry
})

function getConfig() {
  return {
    headers: {
      'Authorization': JSON.parse(localStorage.getItem('token')).value
    }
  }
}

function doLogin(email, password, callback) {
  http.post('/basic_login', {
    email: email,
    password: password
  }).then(function (response) {
    var data = {
      success: true,
      data: {
        email: response.data.email,
        name: response.data.name,
        firstName: response.data.first_name,
        lastName: response.data.lastName,
        phoneNumber: response.data.phone_number,
        token: response.data.token,
        picture: response.data.picture,
        refreshToken: response.data.refresh_token
      }
    }
    callback(data)
  }).catch(function (error) {
    var data = {
      success: false,
      message: error.response.data.message
    }
    callback(data)
  })
}

function doLogout(token, callback) {
  var data = {}
  var config = getConfig()
  http.post('/logout', data, config).then(function (response) {
    var data = {
      success: true,
      message: 'You have successfully logged out'
    }
    callback(data)
  }).catch(function (error) {
    console.log(error)
    var data = {
      success: false,
      message: error.response.data.message
    }
    callback(data)
  })
}

function doValidateToken(token, callback) {
  http.post('/validate_token', {
    token: token
  }).then(function (response) {
    var data = {
      success: true,
      scopes: response.data.user_scopes
    }
    callback(data)
  }).catch(function (error) {
    var data = {
      success: false,
      message: error.response.data.message
    }
    callback(data)
  })
}

function userActivation(userId, email, studentNumber, callback) {
  var data = {
    user_id: userId,
    email: email,
    student_number: studentNumber
  }

  var config = getConfig()
  http.post('/activation/third_party', data, config).then(function (response) {
    var data = {
      success: true,
      data: response.data
    }
    callback(data)
  }).catch(function (error) {
    var data = {
      success: false,
      message: error.response.data.message
    }
    callback(data)
  })
}

function queryUser(data, callback) {

  var config = getConfig()
  http.post('/query/user', data, config).then(function(response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function(error) {
    callback({
      success: false,
      messaeg: error.response.data.message
    })
  })
}

export default { doLogin, doLogout, doValidateToken, userActivation, queryUser }



// WEBPACK FOOTER //
// ./src/services/auth.js